var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_585)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 66,
    height: 66,
    rx: 33,
    fill: "white",
    fillOpacity: 0.8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.125 41.625C46.125 41.3266 46.0064 41.0405 45.7955 40.8295C45.5845 40.6185 45.2983 40.5 45 40.5C44.7016 40.5 44.4154 40.6185 44.2045 40.8295C43.9935 41.0405 43.875 41.3266 43.875 41.625V50.1593L41.2965 47.5785C41.1919 47.4739 41.0677 47.3909 40.931 47.3343C40.7944 47.2777 40.6479 47.2486 40.5 47.2486C40.352 47.2486 40.2056 47.2777 40.0689 47.3343C39.9322 47.3909 39.8081 47.4739 39.7035 47.5785C39.5989 47.6831 39.5159 47.8073 39.4593 47.9439C39.4027 48.0806 39.3735 48.2271 39.3735 48.375C39.3735 48.5229 39.4027 48.6694 39.4593 48.8061C39.5159 48.9427 39.5989 49.0669 39.7035 49.1715L44.2035 53.6715C44.308 53.7763 44.4321 53.8594 44.5688 53.9161C44.7055 53.9728 44.852 54.002 45 54.002C45.1479 54.002 45.2945 53.9728 45.4311 53.9161C45.5678 53.8594 45.692 53.7763 45.7965 53.6715L50.2965 49.1715C50.4011 49.0669 50.484 48.9427 50.5406 48.8061C50.5972 48.6694 50.6264 48.5229 50.6264 48.375C50.6264 48.2271 50.5972 48.0806 50.5406 47.9439C50.484 47.8073 50.4011 47.6831 50.2965 47.5785C50.1919 47.4739 50.0677 47.3909 49.931 47.3343C49.7944 47.2777 49.6479 47.2486 49.5 47.2486C49.352 47.2486 49.2056 47.2777 49.0689 47.3343C48.9322 47.3909 48.8081 47.4739 48.7035 47.5785L46.125 50.1593V41.625Z",
    fill: "#31414F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 58.5V37.125L48.375 27H36C34.8065 27 33.6619 27.4741 32.818 28.318C31.9741 29.1619 31.5 30.3065 31.5 31.5V58.5C31.5 59.6935 31.9741 60.8381 32.818 61.682C33.6619 62.5259 34.8065 63 36 63H54C55.1935 63 56.3381 62.5259 57.182 61.682C58.0259 60.8381 58.5 59.6935 58.5 58.5ZM48.375 33.75C48.375 34.6451 48.7306 35.5036 49.3635 36.1365C49.9964 36.7694 50.8549 37.125 51.75 37.125H56.25V58.5C56.25 59.0967 56.0129 59.669 55.591 60.091C55.169 60.5129 54.5967 60.75 54 60.75H36C35.4033 60.75 34.831 60.5129 34.409 60.091C33.9871 59.669 33.75 59.0967 33.75 58.5V31.5C33.75 30.9033 33.9871 30.331 34.409 29.909C34.831 29.4871 35.4033 29.25 36 29.25H48.375V33.75Z",
    fill: "#31414F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_585",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_585",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.0a7dfa10f1ac4eac74baec4fd01b5c02.svg";
export { ForwardRef as ReactComponent };